
import { computed, defineComponent } from 'vue'
// eslint-disable-next-line no-unused-vars
import { GroupKey, groups, students } from '@/config'
import { useGroupParam, useSearchParam } from '@/hooks/app'
import { searchFor } from '@/utils'
import { groupBy } from 'ramda'
import Student from '@/components/Student.vue'

export default defineComponent({
  name: 'Students',
  components: { Student },
  setup() {
    const group = useGroupParam()

    const search = useSearchParam()

    const studentsList = computed(() => students.filter((student) => (
      (!group.value || group.value === student.group)
      && search.value.split(' ').every((word) => {
        const searchWord = searchFor(word)

        return searchWord(student.firstName) || searchWord(student.lastName)
      })
    )))

    const getGroupTitle = (groupKey: GroupKey) => groups.find(({ key }) => groupKey === key)!.title

    const studentsListByGroup = computed(() => groupBy((student) => getGroupTitle(student.group), studentsList.value))

    return {
      studentsList,
      studentsListByGroup,
    }
  },
})
